module.exports = __webpack_public_path__ + "img/thesis-pana.7aa970a6.svg";